import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import Section from 'components/Section'
import AddButton from 'components/AddButton'
import TermList from './TermList'
import { objectTerms } from 'selectors/lease'

let select = dirtyRead(
	(state, props) => ({
		lease: doc(state, props.objectID)
	  , lastTerm: objectTerms(state, props)[objectTerms(state, props).length-1]
	})
)

export class Terms extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="lease/terms"
				title="Terms"
			>
				<TermList objectID={props.objectID} />
            </Section>
		)
	}
}

export default connect(select, dataActions)(Terms)



// WEBPACK FOOTER //
// ./src/routes/landlord/leaseForm/Terms.js